import React from 'react';
import Toggle from 'material-ui/Toggle';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import DatePicker from 'material-ui/DatePicker';
import TimePicker from 'material-ui/TimePicker';
import EntryList from './EntryList';
import EventList from './EventList';
import PhotoGallery from './PhotoGallery';
import CheckboxOptionsWithTitle from './CheckboxOptionsWithTitle';
import DescriptorList from './DescriptorList';
import DomainList from './DomainList';
import RichTextEditor from './RichTextEditor';
import FlatButton from 'material-ui/FlatButton';
import PhotoUpload from '../containers/PhotoUpload';
import EditDomainForm from '../containers/Website/EditDomainForm';
import ReadyTextField from './TextField';
import ReadyAutoComplete from './ReadyAutoComplete';
import { AmsAPIEndpointURL } from '../constants';

class WebsiteContentField extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      ...props
    };
    this.onUploadPhoto = this.onUploadPhoto.bind(this);
    this.onPhotoReady = this.onPhotoReady.bind(this);
  }

  componentWillUpdate(nextProps, nextState) {
    if (this.state.value !== nextState.value) {
      if (this.props.onChange) {
        this.props.onChange(nextState.value);
      }
    }
  }

  componentWillReceiveProps(nextProps) {
    this.setState({ ...nextProps });
  }

  onAddDomain = (domainProperty) => {
    this.setState({ showAddDomainDialog: true, domainProperty });
  }

  onUploadPhoto = (photoProperty) => {
    this.setState({ showUploadDialog: true, photoProperty });
  }

  onCloseUpload = () => {
    this.setState({ showUploadDialog: false });
  }

  onCloseAddDomainDialog = () => {
    this.setState({ showAddDomainDialog: false });
  }

  onDomainAdded(newValue) {
    this.setState({
      value: [...this.state.value, newValue.domainName],
      showAddDomainDialog: false
    })
  }

  onPhotoReady(url, amsData) {
    this.setState({
      value: amsData
    });
  }

  render() {
    const styles = {
      contentFieldContainer: {
        display: 'flex',
        margin: '4px'
      },
      contentFieldLabel: {
        width: '200px',
        lineHeight: '30px',
        paddingLeft: 20,
        fontSize: 18,
        fontWeight: '400',
        alignItems: 'center'
      },
      contentFieldValue: {
        flex: 1,
      },
      inputText: {
        minHeight: 40,
        maxWidth: 600,
      },
      uploadPhotoArea: {
        width: 160,
        height: 100,
        backgroundColor: '#EFEFEF',
        marginRight: 10,
      },
      photoUploadCriteria: {
        alignItems: 'flex-start',
        justifyContent: 'center',
        marginTop: -10,
      }
    }

    return (
      <div style={styles.contentFieldContainer}>
        { /* Label Field */}
        <div style={styles.contentFieldLabel} className={'content-label'}>
          <div>
            {this.props.icon
              ? <i style={{ marginRight: 6, fontSize: this.props.fontSize }} className={`fa ${this.props.icon}`} />
              : null
            }
          </div>
          <div>
            {this.state.label}
          </div>
        </div>
        { /* Content Field */}
        {this.state.type === 'text'
          ? <div style={styles.contentFieldValue}>
            <ReadyTextField
              style={styles.inputText}
              value={this.state.value}
              readOnly={this.props.readonly}
              onChange={(e) => this.setState({ value: e.target.value })}
              onBlur={(e) => this.setState({ value: e.target.value.trim() })}
              errorText={this.state.valueValidationError}>
            </ReadyTextField>
          </div>
          : this.state.type === 'label'
            ? <div style={styles.contentFieldValue}>
              <span>{this.state.value}</span>
            </div>
            : this.state.type === 'photo'
              ? <div className={'flex-row'}>
                <div style={styles.uploadPhotoArea} className={'flex-center'}>
                  {this.state.value
                    ? this.state.value.mimeType !== 'image/svg+xml'
                      ? <img alt="webphoto" style={{ width: this.props.maxwidth, maxHeight: this.props.maxheight }} src={AmsAPIEndpointURL + '/images/' + this.state.value.id + '/preview/jpg/' + (this.props.maxwidth ? this.props.maxwidth : this.state.value.width.toString()) + '/' + (this.props.maxheight ? this.props.maxheight : this.state.value.height.toString())} />
                      : <img alt="webphoto" style={{ width: this.props.maxwidth, maxHeight: this.props.maxheight }} src={this.state.value.href} />
                    : null
                  }
                  {this.state.showUploadDialog
                    ? <PhotoUpload show={this.state.showUploadDialog} closeDialog={this.onCloseUpload} photoReady={this.onPhotoReady} />
                    : null
                  }
                </div>
                <div style={styles.photoUploadCriteria} className="flex-col">
                  <div style={{ alignItems: 'center' }} className="flex-row">
                    <span style={{ marginRight: 6 }}> photoname.jpg </span>
                    <div>
                      {/* Upload Photo/Domain Button */}
                      {this.state.type === 'photo'
                        ? <div><FlatButton style={{ marginTop: -2, height: 46 }} labelStyle={{ fontSize: 17, fontWeight: 600, color: '#09B0FF', textTransform: 'capitalize' }} onClick={() => this.setState({ showUploadDialog: true })} label="Replace" /></div>
                        : this.state.type === 'domainlist'
                          ? <div><FlatButton onClick={() => this.setState({ showAddDomainDialog: true })} label="Add Domain" /></div>
                          : null
                      }
                    </div>
                  </div>
                  <div>
                    <span className="small-text">Recommended size: <b>{this.props.photoSize} •</b> File Format: <b>{this.props.photoFormat}</b></span>
                  </div>
                </div>
              </div>
              : this.state.type === 'dropdown'
                ? <div style={styles.contentFieldValue}>
                  <SelectField value={this.state.value} onChange={(e, key, payload) => this.setState({ value: payload })}>
                    {this.state.options
                      ? this.state.options.map((option) =>
                        <MenuItem value={option} primaryText={option} />
                      )
                      : null
                    }
                  </SelectField>
                </div>
                : this.state.type === 'menudropdown'
                  ? <div style={styles.contentFieldValue}>
                    <SelectField value={this.state.value} style={{ width: '100%', maxWidth: 600 }} fullWidth={true} onChange={(e, key, payload) => this.setState({ value: payload })}>
                      {this.state.options
                        ? this.state.options.map((option) =>
                          <MenuItem value={option.id} primaryText={option.menu_name} />
                        )
                        : null
                      }
                    </SelectField>
                  </div>
                  : this.state.type === 'richtext'
                    ? <div style={styles.contentFieldValue}>
                      <RichTextEditor
                        value={this.state.value}
                        onChange={(value) => this.setState({ value })}
                      >
                      </RichTextEditor>
                    </div>
                    : this.state.type === 'autocomplete'
                      ? <ReadyAutoComplete filter={ReadyAutoComplete.caseInsensitiveFilter} disabled={this.props.disabled} searchText={this.props.value} dataSource={this.props.dataSource} onNewRequest={this.props.onNewRequest} dataSourceConfig={this.props.dataSourceConfig}></ReadyAutoComplete>
                      : this.state.type === 'photogallery'
                        ? <div style={styles.contentFieldValue}><PhotoGallery photos={this.state.value} /></div>
                        : this.state.type === 'toggle'
                          ? <div style={styles.contentFieldValue}><Toggle defaultToggled={this.state.value} onToggle={(e, newValue) => this.setState({ value: newValue })} className={this.props.className} /></div>
                          : this.state.type === 'toggleWithOptions'
                            ? <div style={styles.contentFieldValue}><Toggle defaultToggled={this.state.value} onToggle={(e, newValue) => this.setState({ value: newValue })} />
                              <ul>
                                <CheckboxOptionsWithTitle title="Required Fields" options={this.state.options} onChange={(options) => this.setState({ options: options })}></CheckboxOptionsWithTitle>
                              </ul>
                            </div>
                            : this.state.type === 'pagelist'
                              ? <div style={styles.contentFieldValue}>
                                <EntryList entries={this.state.value} />
                              </div>
                              : this.state.type === 'eventlist'
                                ? <div style={styles.contentFieldValue}>
                                  <EventList events={this.state.value} />
                                </div>
                                : this.state.type === 'descriptorlist'
                                  ? <div style={styles.contentFieldValue}>
                                    <DescriptorList descriptors={this.state.value} />
                                  </div>
                                  : this.state.type === 'domainlist'
                                    ? <div style={styles.contentFieldValue}>
                                      <DomainList domains={this.state.value} />
                                      {this.state.showAddDomainDialog ? <EditDomainForm show={this.state.showAddDomainDialog} onClose={this.onCloseAddDomainDialog.bind(this)} onSubmit={this.onDomainAdded.bind(this)} /> : null}
                                      <div><FlatButton onClick={() => this.setState({ showAddDomainDialog: true })} label="Add Domain" /></div>
                                    </div>
                                    : this.state.type === 'date'
                                      ? <div style={styles.contentFieldValue}>
                                        <DatePicker hintText="Select Date" mode="landscape" value={this.state.value} onChange={(e, value) => this.setState({ value: value })} />
                                      </div>
                                      : this.state.type === 'time'
                                        ? <div style={styles.contentFieldValue}>
                                          <TimePicker
                                            hintText="Select Time"
                                            value={this.state.value}
                                            onChange={(e, value) => this.setState({ value: value })}
                                          />
                                        </div>
                                        : <div style={styles.contentFieldValue}></div>
        }
      </div>
    );
  }
}

export default WebsiteContentField;



// WEBPACK FOOTER //
// ./src/components/WebsiteContentField.js